import React from 'react';
import Banner from '../../../components/Banner/Banner';
import ProductTable from '../../../components/ProductTable/ProductTable';
import './ITO.css';

// Import images
import itoImage1 from '../../../assets/images/AEA2CEB9-0EE4-4EB5-BA38-733966A87880.jpeg';
import itoImage2 from '../../../assets/images/8C4992A4-4BD1-4E9E-9A9C-950346CE10C1.jpeg';
import itoImage3 from '../../../assets/images/B18E6F27-320E-492C-B8A4-A5889631B5E1.jpeg';
import itoImage4 from '../../../assets/images/7A8ADEDC-B754-41C5-B6B0-196ACDF0F308.jpeg';
import itoSpecialImage1 from '../../../assets/images/IMG_2422.jpg';
import itoSpecialImage2 from '../../../assets/images/IMG_2417.jpg';
import itoSpecialImage3 from '../../../assets/images/IMG_2411.jpg';
import itoSpecialImage4 from '../../../assets/images/IMG_2418-1.jpg';
import itoSpecialImage5 from '../../../assets/images/IMG_2419.jpg';
import itoSpecialImage6 from '../../../assets/images/IMG_2405.jpg';
import lastImage from '../../../assets/images/9BFC796C-E2EF-4E9C-88B8-94CC2085F5F6.jpeg';

const ITO = () => {
  // Data for first table - 25 mm x 75 mm Mikroskop Camı
  const table1Headers = [
    { text: "", colspan: 1 },
    { text: "5'lik paket fiyat (TL)", colspan: 1 },
    { text: "20'lik paket fiyat (TL)", colspan: 1 },
    { text: "50'lik paket fiyat (TL)", colspan: 1 },
  ];
  
  const table1Rows = [
    [
      { content: "Rs &lt; 10 ohm/sq" },
      { content: "1040" },
      { content: "3776" },
      { content: "9416" },
    ],
    [
      { content: "10 &lt; Rs &lt; 15 ohm/sq" },
      { content: "940" },
      { content: "3460" },
      { content: "8622" },
    ],
    [
      { content: "15 &lt; Rs &lt; 25 ohm/sq" },
      { content: "872" },
      { content: "3220" },
      { content: "7852" },
    ],
    [
      { content: "Rs &gt; 25 ohm/sq" },
      { content: "792" },
      { content: "2992" },
      { content: "7072" },
    ],
  ];
  
  // Data for second table - 24 mm x 24 mm Mikroskop Camı
  const table2Headers = [
    { text: "", colspan: 1 },
    { text: "5'lik paket fiyat (TL)", colspan: 1 },
    { text: "20'lik paket fiyat (TL)", colspan: 1 },
    { text: "50'lik paket fiyat (TL)", colspan: 1 },
  ];
  
  const table2Rows = [
    [
      { content: "Rs &lt; 10 ohm/sq" },
      { content: "1040" },
      { content: "3776" },
      { content: "9416" },
    ],
    [
      { content: "10 &lt; Rs &lt; 15 ohm/sq" },
      { content: "940" },
      { content: "3460" },
      { content: "8652" },
    ],
    [
      { content: "15 &lt; Rs &lt; 25 ohm/sq" },
      { content: "872" },
      { content: "3220" },
      { content: "7852" },
    ],
  ];
  
  // Data for third table - ITO on different sizes
  const table3Headers = [
    { text: "", colspan: 1 },
    { text: "Rs &lt; 100 ohm/sq (2 mm veya 3 mm kalınlığında)", colspan: 2 },
    { text: "Rs &lt; 25 ohm/sq (2 mm veya 3 mm kalınlığında)", colspan: 2 },
  ];
  
  const table3Rows = [
    [
      { content: "(cm<sup>2</sup>)" },
      { content: "5'lik paket fiyat (TL)" },
      { content: "20'lik paket fiyat (TL)" },
      { content: "5'lik paket fiyat (TL)" },
      { content: "20'lik paket fiyat (TL)" },
    ],
    [
      { content: "2×6" },
      { content: "–" },
      { content: "1104" },
      { content: "–" },
      { content: "1548" },
    ],
    [
      { content: "3×9" },
      { content: "–" },
      { content: "2456" },
      { content: "–" },
      { content: "3420" },
    ],
    [
      { content: "4×4" },
      { content: "–" },
      { content: "1444" },
      { content: "–" },
      { content: "2024" },
    ],
    [
      { content: "5×10" },
      { content: "1320" },
      { content: "2552" },
      { content: "1840" },
      { content: "6380" },
    ],
    [
      { content: "10×10" },
      { content: "2524" },
      { content: "8804" },
      { content: "3520" },
      { content: "12324" },
    ],
    [
      { content: "20×20" },
      { content: "9744" },
      { content: "34080" },
      { content: "13636" },
      { content: "45564" },
    ],
    [
      { content: "40×60*" },
      { content: "*" },
      { content: "*" },
      { content: "*" },
      { content: "*" },
    ],
    [
      { content: "50×90*" },
      { content: "*" },
      { content: "*" },
      { content: "*" },
      { content: "*" },
    ],
  ];

  return (
    <>
      <Banner title="Indium Kalay Oksit (ITO) Kaplamalar" />
      
      <div className="bizler_section_wrapper">
        <div className="container content-container">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <div className="ito-content">
              <section className="product-intro">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>ITO (Indium tin oxide, indiyum kalay oksit) elektriksel iletken ve optik geçirgen bir ince film kaplama çeşitidir.</p>
                        <p>Güneş pillerinde, elektrokromik camlarda, LCD ekranlarda, OLED displaylerde ve ısı bariyerleri olarak kullanılmaktadır. Teknoma ITO kaplamalar 1.3×10-4 ohm.cm'den düşük özdirence sahip olup görünür bölgede ışık geçirgenliği %85 den yüksektir.</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="product-image">
                        <img src={itoImage1} alt="ITO Coating" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-info">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-image">
                        <img src={itoImage2} alt="ITO Coating" className="img-fluid" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="product-details">
                        <p>İstenilen kalınlıkta cam üzerine kaplanabilmektedir. Şu an standart olarak 2, 3 ve 4 mm'lik float cam (soda cam) kullanılmaktadır.</p>
                        <p>Cam kalınlığı fiyatı değiştirmemektedir. Minimum sipariş 300 TL. Fiyatlarımıza KDV (%20) dahil degildir. Yüksek adetli siparişler için lütfen bilgi alınız.</p>
                        <p>Standart olarak float cam üzerine yapılan ITO kaplamalar isteğe göre farklı malzemelerede kaplanabilmektedir.</p>
                        <p>Detaylı bilgi için lütfen e-mail (info@teknoma.net) atınız.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-images">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-image">
                        <img src={itoImage3} alt="ITO Coating" className="img-fluid" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="product-image">
                        <img src={itoImage4} alt="ITO Coating" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-pricing-note">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h5 className="note-title">Fiyatlara %20 KDV eklenecektir.</h5>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-tables">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="table-header">
                        <h5>25 mm x 75 mm Mikroskop Camı (1.1 mm kalınlığında)</h5>
                      </div>
                      <ProductTable 
                        headers={table1Headers}
                        rows={table1Rows}
                        className="table-1"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-tables">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="table-header">
                        <h5>24 mm x 24 mm Mikroskop Camı (150-170 mikron kalınlığında)</h5>
                      </div>
                      <ProductTable 
                        headers={table2Headers}
                        rows={table2Rows}
                        className="table-2"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-tables">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <ProductTable 
                        headers={table3Headers}
                        rows={table3Rows}
                        className="table-3"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="note-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h5>* ile belirtilen boyutlar ile ilgili fiyatlandırmayı lütfen e-mail yoluyla sorunuz</h5>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="special-products">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h2 className="section-title">Özel Kesilmiş ITO Kaplamalı Camlar (Rs &lt; 10 ohm/sq)</h2>
                    </div>
                  </div>
                  
                  <div className="row product-item">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>10mm x 10mm x 1mm ITO Kaplamalı Cam (Rs &lt; 10 ohm/sq) 50'li paket*</p>
                        <p>xxx TL +KDV</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <figure className="product-figure">
                        <img src={itoSpecialImage1} alt="10mm x 10mm x 1mm ITO Kaplamalı Cam" className="img-fluid" />
                        <figcaption className="figure-caption">10mm x 10mm x 1mm ITO Kaplamalı Cam</figcaption>
                      </figure>
                    </div>
                  </div>
                  
                  <div className="row product-item">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>10mm x 15mm x 1mm ITO Kaplamalı Cam (Rs &lt; 10 ohm/sq) 50'li paket*</p>
                        <p>xxx TL +KDV</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <figure className="product-figure">
                        <img src={itoSpecialImage2} alt="10mm x 15mm x 1mm ITO Kaplamalı Cam" className="img-fluid" />
                        <figcaption className="figure-caption">10mm x 15mm x 1mm ITO Kaplamalı Cam</figcaption>
                      </figure>
                    </div>
                  </div>
                  
                  <div className="row product-item">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>20mm x 10mm x 1mm ITO Kaplamalı Cam (Rs &lt; 10 ohm/sq) 50'li paket*</p>
                        <p>xxx TL +KDV</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <figure className="product-figure">
                        <img src={itoSpecialImage3} alt="20mm x 10mm x 1mm ITO Kaplamalı Cam" className="img-fluid" />
                        <figcaption className="figure-caption">20mm x 10mm x 1mm ITO Kaplamalı Cam</figcaption>
                      </figure>
                    </div>
                  </div>
                  
                  <div className="row product-item">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>20mm x 15mm x 1mm ITO Kaplamalı Cam (Rs &lt; 10 ohm/sq) 50'li paket*</p>
                        <p>xxx TL +KDV</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <figure className="product-figure">
                        <img src={itoSpecialImage4} alt="20mm x 15mm x 1mm ITO Kaplamalı Cam" className="img-fluid" />
                        <figcaption className="figure-caption">20mm x 15mm x 1mm ITO Kaplamalı Cam</figcaption>
                      </figure>
                    </div>
                  </div>
                  
                  <div className="row product-item">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>25mm x 25mm x 1mm ITO Kaplamalı Cam (Rs &lt; 10 ohm/sq) 50'li paket*</p>
                        <p>xxx TL +KDV</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <figure className="product-figure">
                        <img src={itoSpecialImage5} alt="25mm x 25mm x 1mm ITO Kaplamalı Cam" className="img-fluid" />
                        <figcaption className="figure-caption">25mm x 25mm x 1mm ITO Kaplamalı Cam</figcaption>
                      </figure>
                    </div>
                  </div>
                  
                  <div className="row product-item">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-description">
                        <p>75mm x 25mm x 1mm ITO Kaplamalı Cam (Rs &lt; 10 ohm/sq) 50'li paket*</p>
                        <p>xxx TL +KDV</p>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <figure className="product-figure">
                        <img src={itoSpecialImage6} alt="75mm x 25mm x 1mm ITO Kaplamalı Cam" className="img-fluid" />
                        <figcaption className="figure-caption">75mm x 25mm x 1mm ITO Kaplamalı Cam</figcaption>
                      </figure>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-note">
                        <p>*camların bir yüzeyi ITO kaplamalıdır.</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-image-last">
                        <img src={lastImage} alt="ITO Coated Glass" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ITO;